<div class="container">
  <div class="content">
    <app-stepper-header
      title="Hero Report"
      i18n-title="@@heroReportTitle"
      [steps]="steps"
      [step]="step">
    </app-stepper-header>

    <div class="panel-container">
      <div [ngSwitch]="step" class="step-container">
        <app-hero-report-step1 *ngSwitchCase="0" [formGroup]="itemForm">
        </app-hero-report-step1>

        <app-hero-report-step2 *ngSwitchCase="1" [formGroup]="eventForm">
        </app-hero-report-step2>

        <app-hero-report-step3 *ngSwitchCase="2"
                               [formGroup]="evacForm"
                               [possibleIdentification]="itemForm.get('possibleIdentification').value">
        </app-hero-report-step3>
      </div>
      <div class="stepper-actions">
        <button
          pButton
          label="Cancel"
          i18n-label="@@cancelButton"
          class="p-button-text"
          (click)="goBack()">
        </button>

        <button
          *ngIf="step < steps.length - 1"
          pButton
          label="Next"
          i18n-label="@@nextButton"
          class="p-button-primary"
          (click)="nextStep()">
        </button>

        <button
          *ngIf="step === steps.length - 1"
          pButton
          label="Create"
          i18n-label="@@createButton"
          class="p-button-primary"
          (click)="submit()"
          [loading]="isSubmitting">
        </button>

      </div>
    </div>
  </div>
</div>